export default __webpack_public_path__ + "static/media/roboto-black-webfont.fa296b07.ttf";